import { useEffect, useState } from "react";
import axios from "axios";
import { API, fileUrl } from "@/lib/api";

const FALLBACK_TEXT = [
    "GARNIER",
    "MIXA",
    "KALIMERA",
    "EWELANN",
    "NOBI NOBI",
    "SANTOSHA",
    "EFFINITY AGENCE",
    "BODY HOUSE",
    "LES MAUVAIS GARÇONS",
];

export default function Marquee() {
    const [logos, setLogos] = useState([]);
    useEffect(() => {
        axios
            .get(`${API}/logos`)
            .then((r) => {
                if (Array.isArray(r.data) && r.data.length > 0) setLogos(r.data);
            })
            .catch(() => {});
    }, []);

    const items =
        logos.length > 0
            ? [...logos, ...logos]
            : [...FALLBACK_TEXT, ...FALLBACK_TEXT];

    return (
        <section
            data-testid="brands-marquee"
            className="py-12 md:py-16 border-y border-[#E5E5E5] bg-[#FAFAFA] overflow-hidden"
        >
            <p className="eyebrow text-center mb-6">Ils m'ont fait confiance</p>
            <div className="relative">
                <div className="flex marquee-track w-[200%] items-center">
                    {items.map((item, i) => {
                        const isLogo = typeof item === "object";
                        return (
                            <div
                                key={`${isLogo ? item.id : item}-${i}`}
                                className="shrink-0 px-10 flex items-center"
                            >
                                {isLogo ? (
                                    <img
                                        src={fileUrl(item.image_url)}
                                        alt={item.name}
                                        className="h-10 md:h-14 w-auto object-contain max-w-[180px]"
                                        title={item.name}
                                    />
                                ) : (
                                    <span className="font-display italic text-3xl md:text-4xl text-ink whitespace-nowrap">
                                        {item}
                                    </span>
                                )}
                                <span className="ml-10 text-gold text-3xl">✦</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
